import { ApiUtility } from "./ApiUtility";
class SubjectService {
  subjectRoute = "/api/subjects?lang=";
  subjectWithData="/api/subjects"

  getSubjects = (search: any, start: number, length: number) => {
    return ApiUtility.get(
      this.subjectRoute +
        localStorage.getItem("lan") +
        "&search=" +
        search +
        "&start=" +
        start +
        "&length=" +
        length
    );
  };
   
  getSubjectDataById=(subjectId:string,length:number)=>{
    return ApiUtility.get(
      `${this.subjectWithData}/${subjectId}/data?length=${length}`
    );
  }
}
export default new SubjectService();
